export default __webpack_public_path__ + "static/media/2-26-03-maze.e76655e8.m4a";